export default {
	fetchDealers(state, dealers) {
		state.dealers = dealers;
	},
};
